import React, { useCallback, useState } from "react";
import { Link } from "react-router-dom";
import { useRoutePath } from "../../../hooks/useRoutePath";
import getAccessHierachyView from "../../../utils/getAccessHierachyView";
import { AssetStatusArchiving, AssetStatusArchived, AssetStatusRestoring } from "../AssetStatus";
import { MediaImage } from "../components";
import { Box, Checkbox, Skeleton, Divider, Grid, Stack, Typography } from "@mzc-pdc/ui";
import StatusBadge from "@components_v2/status-badge/status-badge";
import theme from "@styles/theme";
import convertToByte from "@cores/convertToByte";
import AssetTypeFlag from "@components_v2/icon-type/asset/asset-type-flag";
import { IconAi, IconDrm, IconLink, IconVoice } from "@mzc-cloudplex/icons";
import { alpha } from "@mui/material";
import menuService from "@services/menuService";
import { useSelector } from "react-redux";
import {
    ASSET_PREVIEW_STATUS,
    ASSET_THUMBNAIL_CARD_CONTAINER_SIZE,
    ASSET_THUMBNAIL_TABLE_CONTAINER_SIZE,
} from "@constants";
import MediaImageWrapper from "@routes/asset/components/media-image-wrapper";
import { useLocation } from "react-router";

const AssetTableCardSkeleton = ({ asset, stageVersion, onChangeSelectItem, selectedItems, checkable }) => {
    const { pathname } = useLocation();
    const { spaceId, projectId } = menuService.parse(pathname);
    return (
        <div className="list-content">
            <Grid container alignItems={"center"} flexWrap={"nowrap"} overflow={"hidden"}>
                {getAccessHierachyView(stageVersion) && checkable && (
                    <Checkbox
                        color={"greySecondary"}
                        disabled={true}
                        checked={false}
                        onChange={() => onChangeSelectItem(asset)}
                        onClick={(e) => {
                            e.stopPropagation();
                        }}
                    />
                )}
                <MediaImageWrapper
                    status={"IN_PROGRESS"}
                    sx={{
                        position: `relative`,
                        minWidth: 44,
                        width: ASSET_THUMBNAIL_TABLE_CONTAINER_SIZE,
                        height: ASSET_THUMBNAIL_TABLE_CONTAINER_SIZE,
                        borderRadius: `4px`,
                        backgroundColor: alpha("#dfdfee", 0.5),
                        overflow: `hidden`,
                        ml: 1,
                        mr: 1.5,
                    }}
                >
                    <MediaImage variant={"table"} errorIconProps={{ position: "left", size: 16 }} asset={asset} />
                </MediaImageWrapper>
                <Stack
                    sx={{
                        flex: 1,
                        overflow: "hidden",
                    }}
                >
                    <Grid
                        container
                        alignItems={"center"}
                        flexWrap={"nowrap"}
                        sx={{ overflow: `hidden` }}
                        width={1}
                        gap={0.75}
                    >
                        <AssetTypeFlag size={"small"} type={asset.mediaType} />
                        <Grid item xs sx={{ textOverflow: `ellipsis`, overflow: `hidden` }}>
                            <Typography variant={"body1_500"} title={asset.name} noWrap>
                                <Link
                                    to={`${menuService.paths.assetsAssetDetail(
                                        spaceId,
                                        projectId,
                                        asset.id,
                                    )}?projectId=${asset.project?.id}`}
                                    style={{ color: `inherit`, ":hover": { textDecoration: `none` } }}
                                >
                                    {asset.name}
                                </Link>
                            </Typography>
                        </Grid>
                    </Grid>
                    <Grid container alignItems={"center"} gap={1} mt={1} flexWrap={"nowrap"}>
                        <Grid item xs>
                            <Skeleton
                                variant="rounded"
                                animation={"wave"}
                                width={122}
                                height={18}
                                sx={{ backgroundColor: alpha("#dfdfee", 0.5) }}
                            />
                        </Grid>
                    </Grid>
                </Stack>
            </Grid>
        </div>
    );
};

export default AssetTableCardSkeleton;
